import { render, staticRenderFns } from "./soEditTable.vue?vue&type=template&id=2c3cb00b&"
import script from "./soEditTable.vue?vue&type=script&lang=js&"
export * from "./soEditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports